"use client";

import { type ReactElement } from "react";
import { Link } from "@tanstack/react-router";
import { A1Heading } from "../../atoms/A1Heading/A1Heading.tsx";
import { AppLayout } from "../../layout/AppLayout/AppLayout.tsx";

export function NotFoundContent(): ReactElement {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight:
          "calc(100dvh - var(--navigation-height) - var(--footer-height))",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <A1Heading as="h1" variant="heading-1">
        404 - Page Not Found
      </A1Heading>
      <p style={{ marginBottom: "2rem", fontSize: "1.2rem", color: "#666" }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: "0.75rem 1.5rem",
          backgroundColor: "#e50914",
          color: "white",
          textDecoration: "none",
          borderRadius: "4px",
          fontWeight: "bold",
        }}
      >
        Go Back Home
      </Link>
    </div>
  );
}

export function NotFound(): ReactElement {
  return (
    <AppLayout>
      <NotFoundContent />
    </AppLayout>
  );
}
